import React from 'react';
import PropTypes from 'prop-types';
import { OptionSelector } from 'components';

const LanguageOption = ({ onChange, value }) => {
  const values = [
    { value: 'en', label: 'en', icon: 'https://cdn.auth0.com/website/playground/flags/en-flag.svg' },
    { value: 'zh', label: 'zh', icon: 'https://cdn.auth0.com/website/playground/flags/zh-flag.svg' },
    { value: 'ja', label: 'jp', icon: 'https://cdn.auth0.com/website/playground/flags/ja-flag.svg' },
    { value: 'de', label: 'de', icon: 'https://cdn.auth0.com/website/playground/flags/de-flag.svg' },
    { value: 'fr', label: 'fr', icon: 'https://cdn.auth0.com/website/playground/flags/fr-flag.svg' },
    { value: 'es', label: 'es', icon: 'https://cdn.auth0.com/website/playground/flags/es-flag.svg' },
    { value: 'it', label: 'it', icon: 'https://cdn.auth0.com/website/playground/flags/it-flag.svg' },
    { value: 'pt-br', label: 'pt-br', icon: 'https://cdn.auth0.com/website/playground/flags/pt-br-flag.svg' }
  ];

  return (
    <span>
      <OptionSelector
        name="language"
        onChange={onChange}
        options={values}
        value={value}
      />
      <a
        className="see-all-languages"
        href="https://auth0.com/docs/libraries/lock/v10/i18n"
        target="_blank"
        rel="noopener noreferrer"
      >
        See all Languages
      </a>
    </span>
  );
};

LanguageOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default LanguageOption;



// WEBPACK FOOTER //
// ./src/components/EditorOption/LanguageOption.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/LanguageOption.js